import { animated, useSpring } from '@react-spring/web'
import React, { useState } from 'react'
import useMeasure from 'react-use-measure'

const AnimateHeightAndOpacity = ({
  isOpen,
  children,
  removeFromFlowWhenClosed = false,
}: {
  isOpen: boolean
  children: React.ReactNode
  removeFromFlowWhenClosed?: boolean
}) => {
  const [ref, bounds] = useMeasure()
  const [isAnimationComplete, setIsAnimationComplete] = useState(!isOpen)

  const height = isOpen ? bounds.height : 0
  const opacity = isOpen ? 1 : 0

  const styles = useSpring({
    height,
    opacity,
    from: { height: 0, opacity: 0 },
    onRest: () => {
      // Only set animation complete when closing (isOpen is false)
      if (!isOpen) {
        setIsAnimationComplete(true)
      }
    },
    onStart: () => {
      // When opening, immediately set animation as not complete
      if (isOpen) {
        setIsAnimationComplete(false)
      }
    },
  })

  // Only apply display: none after the closing animation completes
  const displayStyle =
    removeFromFlowWhenClosed && !isOpen && isAnimationComplete
      ? { display: 'none' }
      : {}

  return (
    <animated.span
      className='ease-linear transition duration-100 overflow-hidden block'
      style={{ ...styles, ...displayStyle }}
    >
      <div ref={ref}>{children}</div>
    </animated.span>
  )
}

export default AnimateHeightAndOpacity
